
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","viewBox":"0 0 350 350","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticStyle:{"height":"100%","transform":"translate(56px,42px)"}},[_c('defs',[_c('rect',{staticStyle:{"position":"relative"},attrs:{"id":"SVGID_1_","width":"100%","height":"100%"}})]),_c('clipPath',{attrs:{"id":"SVGID_2_"}},[_c('use',{attrs:{"width":"100%","height":"100%","xlink:href":"#SVGID_1_"}})]),_c('path',{staticStyle:{"clip-path":"url(#SVGID_2_)","margin":"40px"},attrs:{"d":"M128.3 87.8c-11.9 0-18.8 5.4-22.1 9-.4-3.2-2.5-7.3-10.7-7.3H77.6v18.6h7.3c1.2 0 1.6.4 1.6 1.6v85.1h21.2v-34.2c3.3 3 9.6 7.2 19.5 7.2 20.7 0 35.2-16.4 35.2-40 .1-23.9-13.7-40-34.1-40m-4.3 61.5c-11.4 0-16.6-10.9-16.6-21.1 0-16 8.7-21.7 16.9-21.7 10 0 16.8 8.6 16.8 21.5-.1 14.8-8.7 21.3-17.1 21.3","clip-path":"url(#SVGID_2_)","fill":"#203232"}})])])
          )
        }
      }
    